import axios from 'axios';

const publicApi = axios.create({
  baseURL: `${process.env.REACT_APP_PUBLIC_API_URL}`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// No auth interceptors needed for public APIs
export const getJobs = async (payload) => {
    try {
        const response = await publicApi.post(`/jobs/search`, payload);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getJobById = async (jobId) => {
    try {
        const response = await publicApi.get(`/jobs/${jobId}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getSimilarJobs = async (jobId) => {
    try {
        const response = await publicApi.get(`/jobs/${jobId}/similar`);
        return response.data;
    } catch (error) {
        throw error;
    }
};